export default function createStyles(getOption) {
  return {
    base: {
      paddingLeft: '5px',
      fontSize: '14px',
      border: '1px solid var(--searchbar-background-color)',
      borderRadius: '4px'
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/LinkTextBox/styles.js